import { Link, useParams } from "react-router-dom";
import Header from "../../components/layout/Header/Header";
import Footer from "../../components/layout/Footer/Footer";
import Container from "../../components/layout/Container/Container";
import { useBlogPost } from "../../api/queries/useBlogPost";
import { useGallery } from "../../api/queries/useGallery";
import s from "./BlogPostPage.module.scss";
import VideoPlayer from "components/sections/VideoPlayer/VideoPlayer";

function resolveImageSrc(path?: string) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("/")) return path;
  return `/${path}`;
}

export default function BlogPostPage() {
  const { id } = useParams();
  const numericId = id ? Number(id) : undefined;

  const { data, isLoading, isError } = useBlogPost(numericId);
  const { data: gallery } = useGallery();

  const previewId = data?.preview_image_id;

  const previewPath =
    previewId && gallery
      ? gallery.find((g) => g.id === previewId)?.image_path
      : undefined;

  const imgSrc = resolveImageSrc(previewPath);
  const isVerticalVideo = Boolean(data?.is_vertical_video);

  return (
    <div className={s.pageWrap}>
      <Header />

      <main className={s.page}>
        <Container className={s.container}>
          <Link to="/blog" className={s.back}>
            ← В акции
          </Link>

          {isLoading && <div className={s.state}>Загружаем…</div>}
          {isError && <div className={s.state}>Не удалось загрузить пост</div>}

          {!isLoading && !isError && data && (
            <article className={s.article}>
              <h1 className={s.title}>{data.title}</h1>

              {imgSrc && (
                <div className={s.heroImg}>
                  <img
                    src={imgSrc}
                    alt={data.title}
                    className={s.heroImgTag}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              )}

              {data.published_at && (
                <div className={s.meta}>
                  {new Date(data.published_at).toLocaleDateString("ru-RU")}
                </div>
              )}

              {data.preview_text && <p className={s.p}>{data.preview_text}</p>}

              {data.content_0 && <p className={s.content_0}>{data.content_0}</p>}

              {data.video_id && (
                <div className={s.videoWrap}>
                  <div className={isVerticalVideo ? s.videoBoxVertical : s.videoBox}>
                    <VideoPlayer
                      videoId={data.video_id}
                      isVertical={isVerticalVideo}
                    />
                  </div>
                </div>
              )}

              {data.content_1 && <p className={s.p}>{data.content_1}</p>}
            </article>
          )}
        </Container>
      </main>

      <Footer />
    </div>
  );
}
